import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_ONLINE_BOOK_PAGINATION } from "../Schema/OnlineBook";

const useGetOnlineBookPagination = ({ groupFeeId, type }) => {
  const storedPage = window.localStorage.getItem("pageNum");
  const [page, setPage] = useState(storedPage ? parseInt(storedPage) : 1);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState("");
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [paginationData, setPaginationData] = useState();

  const { error, refetch } = useQuery(GET_ONLINE_BOOK_PAGINATION, {
    variables: {
      page,
      limit,
      pagination: true,
      keyword: keyword ?? "",
      groupFeeId: groupFeeId ? groupFeeId : "",
      type: type ? type : "all",
    },
    onCompleted: ({ getOnlineBookPagination }) => {
      setTableData(getOnlineBookPagination?.data);
      setPaginationData(getOnlineBookPagination?.paginator);
      setLoading(false);
    },
  });

  useEffect(() => {
    if (page) {
      // console.error("Error fetching lesson:", error.message);
      window.localStorage.setItem("pageNum", parseInt(page));
    }
  }, [page]);

  useEffect(() => {
    if (error) {
      console.error("Error fetching lesson:", error.message);
    }
  }, [error]);

  const handleSearch = (e) => {
    setPage(1);
    setKeyword(e.target.value);
  };

  const handleLimit = (e) => {
    setLimit(Number(e.target.value));
    setPage(1);
  };

  return {
    page,
    limit,
    setPage,
    refetch,
    loading,
    setLoading,
    error,
    handleSearch,
    tableData,
    paginationData,
    handleLimit,
  };
};

export default useGetOnlineBookPagination;
